import api from './axiosConfig';

export interface DashboardData {
  totalEmployees: number;
  activeEmployees: number;
  presentToday: number;
  absentToday: number;
  onLeaveToday: number;
  totalDepartments: number;
  totalBranches: number;
  attendanceRate: number;
  newJoineesThisMonth: number;
  departmentStats: DepartmentStat[];
  recentEmployees: RecentEmployee[];
  weeklyAttendance: AttendanceTrend[];
}

export interface DepartmentStat {
  departmentName: string;
  employeeCount: number;
}

export interface RecentEmployee {
  id: string;
  fullName: string;
  email: string;
  department: string;
  designation: string;
  dateOfJoining: string;
}

export interface AttendanceTrend {
  day: string;
  present: number;
  absent: number;
  total: number;
}

export interface BirthdayItem {
  employeeId: string;
  employeeCode: string;
  fullName: string;
  email?: string | null;
  departmentName?: string | null;
  designationName?: string | null;
  dateOfBirth: string;
  profileImagePath?: string | null;
  profileImageUrl?: string | null;
}

export interface AnniversaryItem {
  employeeId: string;
  employeeCode: string;
  fullName: string;
  email?: string | null;
  departmentName?: string | null;
  designationName?: string | null;
  joinedDate: string;
  yearsCompleted: number;
  profileImagePath?: string | null;
  profileImageUrl?: string | null;
}

export interface NewJoinerItem {
  employeeId: string;
  employeeCode: string;
  fullName: string;
  email?: string | null;
  departmentName?: string | null;
  designationName?: string | null;
  joinedDate: string;
  profileImagePath?: string | null;
  profileImageUrl?: string | null;
}

export interface DashboardCelebrationsData {
  birthdays: BirthdayItem[];
  anniversaries: AnniversaryItem[];
  newJoiners: NewJoinerItem[];
}

export const dashboardApi = {
  getData: async (): Promise<DashboardData> => {
    const response = await api.get<DashboardData>('/dashboard');
    return response.data;
  },

  getCelebrations: async (): Promise<DashboardCelebrationsData> => {
    const response = await api.get<DashboardCelebrationsData>('/dashboard/celebrations');
    return response.data;
  },
};
